import { render } from "./ListeFactureSPage.vue?vue&type=template&id=1ccbc026&ts=true"
import script from "./ListeFactureSPage.vue?vue&type=script&lang=ts"
export * from "./ListeFactureSPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__